export const API_DATE_FORMAT = 'MM.DD.YYYY mm:ss';
